module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingstatus),
      expression: "loadingstatus"
    }],
    staticClass: "wrapper wrapper-content h100pp",
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('div', {
    staticClass: "float-e-margins ibox-content animated fadeInRight h100pp"
  }, [_c('div', {
    staticClass: "row h100pp",
    staticStyle: {
      "overflow": "auto",
      "height": "calc(100% - 70px)"
    }
  }, [_c('div', {
    staticClass: "form-horizontal h100pp"
  }, [_c('div', {
    staticClass: "col-sm-3 gray_right02 h100pp"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.toSync
    }
  }, [_vm._v("一键同步")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-rigth"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.addCarBrand
    }
  }, [_vm._v("添加品牌")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 gray_left02 h100pp"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 h100p"
  }, [(_vm.fatr == 3) ? _c('div', {
    staticClass: "col-sm-12 text-center "
  }, [_c('p', {
    staticStyle: {
      "line-height": "100%"
    }
  }, [_vm._v("请维护车辆信息")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fatr == 1),
      expression: "fatr==1"
    }],
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.carBrandEditMsg))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "center-block text-center"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("品牌名称")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carBrand.name),
      expression: "carBrand.name"
    }],
    staticClass: "form-control menuInput",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.carBrand.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.carBrand, "name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "center-block text-center"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("全称")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carBrand.fullName),
      expression: "carBrand.fullName"
    }],
    staticClass: "form-control menuInput",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.carBrand.fullName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.carBrand, "fullName", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "center-block text-center"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("首字母")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carBrand.initial),
      expression: "carBrand.initial"
    }],
    staticClass: "form-control menuInput",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.carBrand.initial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.carBrand, "initial", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "center-block text-center"
  }, [_c('label', {
    staticClass: "col-sm-3  control-label"
  }, [_vm._v("LOGO")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "uploadedImg t_left col-sm-3",
    staticStyle: {
      "height": "100px",
      "line-height": "100px",
      "width": "100px"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.logoSrcBrand
    }
  })]), _vm._v(" "), _c('vue-core-image-upload', {
    class: ['btn', 'btn-primary', 'col-sm-2', 'col-offset-sm-1'],
    attrs: {
      "extensions": "png,gif,jpeg,jpg",
      "input-accept": "image/jpg,image/jpeg,image/png",
      "crop": false,
      "text": "上传",
      "inputOfFile": "file",
      "url": _vm.picUrl,
      "headers": {
        'access-token': this.accesstoken
      }
    },
    on: {
      "imageuploaded": _vm.imageuploadedBrand
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "col-sm-7 control-label gray t_left"
  }, [_vm._v("请上传jpg、jpeg或png格式的图片")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "text-center form-group col-sm-9"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.confirmBrand
    }
  }, [_vm._v(_vm._s(_vm.carBrandEditBtn))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fatr == 2),
      expression: "fatr==2"
    }],
    staticClass: "col-sm-12 h100pp"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.carSeriesEditMsg))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "center-block text-center"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("车系")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carSeries.serialName),
      expression: "carSeries.serialName"
    }],
    staticClass: "form-control menuInput",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.carSeries.serialName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.carSeries, "serialName", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "center-block text-center"
  }, [_c('label', {
    staticClass: "col-sm-3  control-label"
  }, [_vm._v("LOGO")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "uploadedImg t_left col-sm-3",
    staticStyle: {
      "height": "100px",
      "line-height": "100px",
      "width": "100px"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.logoSrcSeries
    }
  })]), _vm._v(" "), _c('vue-core-image-upload', {
    class: ['btn', 'btn-primary', 'col-sm-2', 'col-offset-sm-1'],
    attrs: {
      "extensions": "png,gif,jpeg,jpg",
      "input-accept": "image/jpg,image/jpeg,image/png",
      "crop": false,
      "text": "上传",
      "inputOfFile": "file",
      "url": _vm.picUrl,
      "headers": {
        'access-token': this.accesstoken
      }
    },
    on: {
      "imageuploaded": _vm.imageuploadedSeries
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "col-sm-7 control-label gray t_left"
  }, [_vm._v("请上传jpg、jpeg或png格式的图片")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "text-center form-group col-sm-9"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.confirmSeries
    }
  }, [_vm._v(_vm._s(_vm.carSeriesEditBtn))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fatr == 0),
      expression: "fatr==0"
    }],
    staticClass: "col-sm-12 h00pp"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.carTypeEditMsg))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("车型")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carType.modelName),
      expression: "carType.modelName"
    }],
    staticClass: "form-control menuInput",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.carType.modelName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.carType, "modelName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "center-block text-center"
  }, [_c('label', {
    staticClass: "col-sm-3  control-label"
  }, [_vm._v("LOGO")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "uploadedImg t_left col-sm-3",
    staticStyle: {
      "height": "100px",
      "line-height": "100px",
      "width": "100px"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.logoSrcType
    }
  })]), _vm._v(" "), _c('vue-core-image-upload', {
    class: ['btn', 'btn-primary', 'col-sm-2', 'col-offset-sm-1'],
    attrs: {
      "extensions": "png,gif,jpeg,jpg",
      "input-accept": "image/jpg,image/jpeg,image/png",
      "crop": false,
      "text": "上传",
      "inputOfFile": "file",
      "url": _vm.picUrl,
      "headers": {
        'access-token': this.accesstoken
      }
    },
    on: {
      "imageuploaded": _vm.imageuploadedType
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "col-sm-7 control-label gray t_left"
  }, [_vm._v("请上传jpg、jpeg或png格式的图片")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "text-center form-group col-sm-9"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.confirmType
    }
  }, [_vm._v(_vm._s(_vm.carTypeEditBtn))])])])])])])])]), _vm._v(" "), _c('sub-modal', {
    ref: "modal2",
    attrs: {
      "size": "small",
      "title": "温馨提示"
    }
  }, [_c('p', {
    domProps: {
      "textContent": _vm._s(_vm.tipContent)
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.closeSub('modal2')
      }
    }
  }, [_vm._v("确定")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "ibox-content",
    staticStyle: {
      "position": "absolute",
      "overflow": "auto"
    }
  }, [_c('ul', {
    staticClass: "ztree",
    staticStyle: {
      "height": "600px",
      "width": "350px"
    },
    attrs: {
      "id": "carTree"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-871ef2fc","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/vehiclebrand/PageVehicleBrandEdit.vue
// module id = 1598
// module chunks = 0